import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { autoLombardService } from "../../services/autolombard-service";
import {
  approveRequestSuccess,
  fetchDocumentFailure,
  fetchDocumentSuccess,
  fetchRequestSuccess,
  fetchRequestsFailure,
  fetchRequestsSuccess,
  getRequestClientsFailure,
  getRequestClientsSuccess,
  inprogressRequestFailure,
  inprogressRequestSuccess,
  rejectRequestSuccess,
  updateRequestFailure,
  updateRequestSuccess,
  fetchChangeHistorySuccess,
  setCommentsSuccess,
  createOneAppClientSuccess,
  createOneAppClientFailure,
  autoDebtLoadSuccess,
  cancelRequestSuccess,
  creditRegisterSuccess, creditRegisterFailed, fetchPaymentScheduleSuccess, fetchPaymentScheduleError,
} from "../actions/autoLombardActions";
import {
  APPROVE_REQUEST, AUTO_DEBT_LOAD_REQUEST, CANCEL_REQUEST, CHANGE_HISTORY,
  CREATE_ONEAPP_CLIENT_REQUEST, CREDIT_REGISTER_REQUEST,
  FETCH_DOCUMENT_REQUEST, FETCH_PAYMENT_SCHEDULE_REQUEST,
  FETCH_REQUEST,
  FETCH_REQUESTS,
  GENERATE_CREDIT_CALCULATION_REPORT,
  GET_REQUEST_CLIENTS,
  INPROGRESS_STATUS_REQUEST,
  REJECT_REQUEST, SET_COMMENTS,
  UPDATE_REQUEST, WITHDRAW_CAR_DEPOSIT_REQUEST,
} from "../actions/actionTypes";
import { messages } from "../../helpers/messages";
import { reportService } from "../../services/report-service";

function* handleSagaError(error, failureAction) {
  let errorMessage = messages["0"];
  if (error.message) {
    errorMessage = error.message;
  } else if (error.response?.data?.errorCode) {
    errorMessage =
      messages[error.response.data.errorCode] ||
      error.response.data.message ||
      messages["0"];
  }
  yield put(failureAction(errorMessage));
}

function* fetchRequestsSaga(action) {
  try {
    const response = yield call(autoLombardService.getRequests, action.payload);
    yield put(fetchRequestsSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* fetchPaymentScheduleSaga(action) {
  try {
    const response = yield call(autoLombardService.getPaymentSchedule, action.payload);
    yield put(fetchPaymentScheduleSuccess(response.data));
  } catch (error) {
    const err = error.response?.data?.errorCode
    yield put(fetchPaymentScheduleError(messages[err]));
  }
}

function* fetchChangeHistorySaga(action) {
  if (!action.payload?.id) return;
  try {
    const response = yield call(autoLombardService.fetchChangeHistory, action.payload);
    yield put(fetchChangeHistorySuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* fetchRequestSaga(action) {
  try {
    const { id } = action.payload;
    const response = yield call(autoLombardService.getRequestById, id);
    yield put(fetchRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* setCommentsSaga(action) {
  try {
    const response = yield call(autoLombardService.setComments, action.payload);
    yield put(setCommentsSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* inProgressRequestSaga(action) {
  try {
    const { requestId } = action.payload;
    const response = yield call(autoLombardService.inprogressRequest, { requestId });
    yield put(inprogressRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, inprogressRequestFailure);
  }
}

function* approveRequestSaga(action) {
  try {
    const { requestId, data } = action.payload;
    const response = yield call(autoLombardService.approveRequest, {
      requestId,
      data,
    });
    yield put(approveRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* rejectRequestSaga(action) {
  try {
    const { requestId, data } = action.payload;
    const response = yield call(autoLombardService.rejectRequest, {
      requestId,
      data,
    });
    if (response.status === 200) {
      yield put(rejectRequestSuccess(response.data));
    }
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* cancelRequestSaga(action) {
  try {
    const { requestId } = action.payload;
    const response = yield call(autoLombardService.cancelRequest, { requestId});
    yield put(cancelRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, fetchRequestsFailure);
  }
}

function* getRequestClients(action) {
  try {
    const { data } = yield call(
      autoLombardService.getRequestClients,
      action.payload
    );
    yield put(getRequestClientsSuccess(data.content));
  } catch (error) {
    yield* handleSagaError(error, getRequestClientsFailure);
  }
}

function* fetchDocumentSaga(action) {
  try {
    const { documentId, documentType } = action.payload;
    const { data } = yield call(autoLombardService.getDocumentById, {
      documentId,
      documentType
    });
    yield put(fetchDocumentSuccess(data));
  } catch (error) {
    yield put(fetchDocumentFailure(error.message));
  }
}

function* generateCreditCalculationReportSaga(action) {
  try {
    const { code, reportData } = action.payload;
    const { data } = yield call(() => reportService.generateReport(code, reportData));
    yield put(fetchDocumentSuccess({document: data.content}));
  } catch (error) {
    yield put(fetchDocumentFailure(error));
  }
}

function* updateRequestSaga(action) {
  try {
    const { requestId, data } = action.payload;
    const res = yield call(autoLombardService.updateRequest, {requestId, data});
    yield put(updateRequestSuccess(res.data));
  } catch (error) {
    yield* handleSagaError(error, updateRequestFailure);
  }
}

function* createOneAppClientSaga(action) {
  try {
    const { albClientId, requestId } = action.payload;
    yield call(autoLombardService.createOneAppClient, {albClientId});
    yield put(createOneAppClientSuccess());
    const response = yield call(autoLombardService.getRequestById, requestId);
    yield put(fetchRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, createOneAppClientFailure);
  }
}

function* creditRegisterSaga(action) {
  try {
    const response = yield call(autoLombardService.creditRegister, action.payload.payload);
    if (response?.data?.code === 200) {
      const requestResponse = yield call(autoLombardService.getRequestById, action.payload.requestId);
      yield put(fetchRequestSuccess(requestResponse.data));
    }
    yield put(creditRegisterSuccess(response));
  } catch (error) {
    yield put(creditRegisterFailed(messages[0]));
  }
}

function* debtLoadRequestSaga(action) {
  try {
    const { oneClientId, requestId, data } = action.payload;
    const response = yield call(autoLombardService.debtLoadRequest, {oneClientId, data});
    yield put(autoDebtLoadSuccess(response.data));
    const requestResponse = yield call(autoLombardService.getRequestById, requestId);
    yield put(fetchRequestSuccess(requestResponse.data));
  } catch (error) {
    yield* handleSagaError(error, createOneAppClientFailure);
  }
}

function* withdrawCarDeposit(action) {
  try {
    const response = yield call(autoLombardService.withdrawCarDeposit, action.payload.requestId);
    yield put(fetchRequestSuccess(response.data));
  } catch (error) {
    yield* handleSagaError(error, createOneAppClientFailure);
  }
}

function* watchRequests() {
  yield takeEvery(FETCH_REQUESTS, fetchRequestsSaga);
}

function* watchPaymentSchedule() {
  yield takeEvery(FETCH_PAYMENT_SCHEDULE_REQUEST, fetchPaymentScheduleSaga);
}

function* watchSetComments() {
  yield takeEvery(SET_COMMENTS, setCommentsSaga);
}

function* watchRequest() {
  yield takeEvery(FETCH_REQUEST, fetchRequestSaga);
}

function* watchApproveRequest() {
  yield takeEvery(APPROVE_REQUEST, approveRequestSaga);
}

function* watchChangeHistory() {
  yield takeEvery(CHANGE_HISTORY, fetchChangeHistorySaga);
}

function* watchRejectRequestSaga() {
  yield takeEvery(REJECT_REQUEST, rejectRequestSaga);
}

function* watchRequestClientsSaga() {
  yield takeEvery(GET_REQUEST_CLIENTS, getRequestClients);
}

function* watchFetchDocumentSaga() {
  yield takeEvery(FETCH_DOCUMENT_REQUEST, fetchDocumentSaga);
}

function* watchInProgressRequestSaga() {
  yield takeEvery(INPROGRESS_STATUS_REQUEST, inProgressRequestSaga);
}

function* watchUpdateRequestSaga() {
  yield takeEvery(UPDATE_REQUEST, updateRequestSaga);
}

function* watchCreateOneAppClientSaga() {
  yield takeEvery(CREATE_ONEAPP_CLIENT_REQUEST, createOneAppClientSaga);
}

function* watchCreditRegisterSaga() {
  yield takeEvery(CREDIT_REGISTER_REQUEST, creditRegisterSaga);
}

function* watchDebtLoadRequestSaga() {
  yield takeEvery(AUTO_DEBT_LOAD_REQUEST, debtLoadRequestSaga);
}

function* watchCreditCalculationReportSaga() {
  yield takeEvery(GENERATE_CREDIT_CALCULATION_REPORT, generateCreditCalculationReportSaga);
}

function* watchСancelRequestSaga() {
  yield takeEvery(CANCEL_REQUEST, cancelRequestSaga);
}

function* withdrawCarDepositSaga() {
  yield takeEvery(WITHDRAW_CAR_DEPOSIT_REQUEST, withdrawCarDeposit);
}

export {
  watchRequests,
  watchRequest,
  watchApproveRequest,
  watchRejectRequestSaga,
  watchRequestClientsSaga,
  watchFetchDocumentSaga,
  watchInProgressRequestSaga,
  watchUpdateRequestSaga,
  watchChangeHistory,
  watchSetComments,
  watchCreateOneAppClientSaga,
  watchDebtLoadRequestSaga,
  watchCreditCalculationReportSaga,
  watchСancelRequestSaga,
  watchCreditRegisterSaga,
  withdrawCarDepositSaga,
  watchPaymentSchedule
};
